import EditRounded from "@material-ui/icons/EditRounded";
import ArchiveRounded from "@material-ui/icons/ArchiveRounded";
import DeleteRounded from "@material-ui/icons/DeleteRounded";
import { LinkButton } from "../../components/BasicButton";
import { archiveNews, deleteNews, useNewsList } from "../../misc/lib/news";
import routes from "../../misc/routes";
import { useHistory } from "react-router";

const NewsAdminPanel = () => {
  const newsList = useNewsList();
  const history = useHistory();

  return (
    <div className="adminpage-news-panel">
      <LinkButton text="Új hír feltöltése" to={ routes.admin.children.uploadNews.path } />
      <div className="news-list-container">
        <h2>{ newsList.length === 0 ? 'Nincsenek hírek' : 'Hírek' }</h2>
        <div className="news-list">
          { newsList.map((news, i) => (
            <div className="news-card" key={ i }>
              <a href={ routes.news.children.specificNews.path.replace(':id', news.id) }>
                <h3>{ news.title }</h3>
              </a>
              <p>
                ID: <b>{ news.id }</b><br />
                Feltöltve: <b>{ news.timestamp.toDate().toLocaleString() }</b>
              </p>
              <span onClick={ () => {
                history.push(routes.admin.children.editNews.path.replace(':id', news.id));
              } }><EditRounded color="inherit" /></span>
              <span onClick={ () => {
                archiveNews(news.id);
              } }><ArchiveRounded color="inherit" /></span>
              <span onClick={ () => {
                deleteNews(news.id);
              } }><DeleteRounded color="inherit" /></span>
            </div>
          )) }
        </div>
      </div>
    </div>
  );
};

export default NewsAdminPanel;
